<template>
  <div class="workorder-info">
    <div class="flex justify-content-space-between" style="padding: 0 30px;margin-bottom:20px;">
      <div
        v-for="(item,index) in selectors"
        :key="'sele'+ item.key"
        class="selector-item flex"
        :class="[activeKey == item.key&&'is_active', index<2&&'mr']"
        role="button"
        @click="handleKey(item.key)"
      >
        <div class="bd pt pb pl">{{item.name}}</div>
        <div class="ft number pr flex-center font-lg">{{ stats[item.valKey] }}</div>
      </div>
    </div>

    <el-scrollbar
      v-loading="loading"
      :native="false"
      view-class="p-30"
      style="height: calc(100vh - 390px);"
    >
      <div v-for="order in orders" :key="order.workorderid" class="mb-sm">
        <workorder-popover :workorderInfo="order">
          <el-card role="button" style="border:0;">
            <div class="text-muted">{{ order.workorder_no}}</div>
            <div class="font-20 mb-sm ellipsis">{{ order.workorder_title}}</div>
            <workorder-process :workorderInfo="order"></workorder-process>
          </el-card>
        </workorder-popover>
      </div>

      <div v-if="!orders.length" class="flex-center column mt-hg">
        <img class="image huger mt-mg" src="@/assets/empty.png" />
        <div class="font-md mb-hg">暂无数据</div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import WorkorderPopover from "../../mes/components/WorkorderPopover.vue";
import WorkorderProcess from "../../mes/components/WorkorderProcess.vue";
import {
  getStationWorkorderStatApi,
  getStationWorkorderListApi,
} from "@/api/pp/stationApi";
export default {
  components: { WorkorderPopover, WorkorderProcess },
  props: {
    stationid: {
      type: [Number, String],
    },
  },
  data() {
    return {
      loading: false,
      selectors: [
        {
          name: "待开工工单",
          key: "1",
          valKey: "count_workorder_tostart",
        },
        {
          name: "进行中工单",
          key: "2",
          valKey: "count_workorder_toend",
        },
        {
          name: "今日已完工",
          key: "3",
          valKey: "count_workorder_end_today",
        },
      ],
      activeKey: "1",
      orders: [],
      stats: {
        count_workorder_tostart: 0,
        count_workorder_toend: 0,
        count_workorder_end_today: 0,
      },
    };
  },

  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      getStationWorkorderStatApi({ stationid: this.stationid }).then((res) => {
        if (!res.errno) {
          this.stats = res.data;
        }
      });

      getStationWorkorderListApi({
        stationid: this.stationid,
        status: Number(this.activeKey),
      }).then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.orders = res.data.list;
        }
      });
    },
    handleKey(key) {
      if (key == this.activeKey) {
        this.activeKey = "";
      } else {
        this.activeKey = key;
      }

      this.fetchData();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.workorder-info {
  height: calc(100% - 40px);

  .selector-item {
    width: 170px;
    background-color: #f6f8f7;

    &:hover {
      opacity: 0.8;
    }
  }

  .is_active {
    color: $--color-primary;
  }

  /deep/.p-30 {
    padding: 0px 30px;
  }
}
</style>